<template>
	<footer class="layout-wrapper" id="contacts">
		<section>
			<div class="row-btw">
				<div>
					<h3 class="h-text">
						<span>Возникли вопросы?</span>
						<span class="h-text2"> свяжитесь с нами</span>
					</h3>

					<p class="description">
						Проконсультируем и подготовим коммерческое предложение с
						указанием цен и сроками доставки
					</p>
				</div>

				<div class="call-us">
					<UIShLinkSocial
						icon="tg-social"
						:link="CONTACTS.tg.link"
						kind="white"
						md
						:lg="1920"
					/>
					<UIShButton
						class="btn-call"
						label="Заказать обратный звонок"
						md
						:lg="1920"
						@click="toggleOrderPopup"
					/>
				</div>
			</div>

			<ul class="addresses">
				<li class="li-btn">
					<UIShLink external :to="CONTACTS.phone1.link" class="link">
						<p class="title">Телефон</p>
						<p>{{ CONTACTS.phone1.label }}</p>
					</UIShLink>
					<NuxtImg
						alt="phone"
						width="170"
						height="170"
						src="/images/phone.png"
						class="image"
						format="webp"
						loading="lazy"
						decoding="async"
						sizes="sm:80vw xl:100vw"
					/>
				</li>

				<li class="li-btn">
					<UIShLink external :to="CONTACTS.mail.link" class="link">
						<p class="title">Почта</p>
						<p>{{ CONTACTS.mail.label }}</p>
					</UIShLink>
					<NuxtImg
						alt="mail"
						width="170"
						height="170"
						src="/images/mail.png"
						class="image"
						format="webp"
						loading="lazy"
						decoding="async"
						sizes="sm:80vw xl:100vw"
					/>
				</li>

				<li>
					<p class="title">Юридический адрес</p>
					<p>
						432027, Ульяновская обл., г. Ульяновск, Ленинский р-н,
						ул. Казанская, д. 1А, пом. 13
					</p>
				</li>
			</ul>

			<ul class="info">
				<li>© ООО «Агентство Правильных Перевозок», {{ YEAR }}</li>
				<li>
					<p class="values">
						<span>ИНН 7300030591</span>
						<span>КПП 730001001</span>
						<span>ОГРН 1247300002575</span>
					</p>
				</li>

				<li>
					<UIShLink
						label="Политика конфиденциальности"
						xs
						:md="1920"
						to="/privacy"
					/>
				</li>
			</ul>

			<NuxtImg
				alt="cubes"
				width="580"
				height="440"
				src="/images/cubes.png"
				decoding="async"
				loading="lazy"
				class="box-image"
				sizes="sm:60vw xl:100vw"
			/>

			<div class="rect">
				<div />
			</div>
		</section>

		<OrderPopup v-if="dOrderPopup" @close="toggleOrderPopup" />
	</footer>
</template>

<script setup lang="ts">
import { CONTACTS } from '@/common/constants';

const YEAR = new Date().getFullYear();

const dOrderPopup = ref(false);

function toggleOrderPopup() {
	dOrderPopup.value = !dOrderPopup.value;
}
</script>

<style lang="scss" scoped>
footer {
	padding: 0;
	margin-top: 4.444rem;

	section {
		padding: 0 0.667rem;
		padding-top: 12rem;
		background-color: var(--color-gray900);
		border-top-left-radius: 1.333rem;
		border-top-right-radius: 1.333rem;
		position: relative;

		& > * {
			z-index: var(--z-index-footer);
			position: relative;
		}

		.box-image {
			width: 14.667rem;
			height: 11.111rem;
			left: 2.7rem;
			top: -0.5rem;
			position: absolute;
			z-index: var(--z-index);
		}

		.rect {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: inherit;
			overflow: hidden;
			z-index: 0;
			user-select: none;

			div {
				position: relative;
				width: 100%;
				height: 100%;

				&::before {
					content: '';
					left: 2rem;
					top: -4rem;
					width: 13.5rem;
					height: 13.333rem;
					position: absolute;
					transform: rotate(345deg);
					background-color: var(--color-gray800);
				}
			}
		}
	}
}

.h-text {
	@include useFont(dxsb);
	text-transform: uppercase;
	color: var(--color-white);
	max-width: 18.667rem;

	&2 {
		color: var(--color-gray300);
	}
}

.description {
	@include useFont(tmdm);
	margin-top: 0.444rem;
	color: var(--color-white);
	max-width: 18.667rem;
}

.call-us {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 0.667rem;
	margin-top: 1.778rem;

	.btn-call {
		width: 100%;
	}
}

.addresses {
	display: flex;
	flex-direction: column;
	gap: 0.667rem;
	margin-top: 3.444rem;

	li {
		position: relative;
		border-radius: 1.111rem;
		padding: 0.889rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 0.667rem;
		@include useFont(tlgs);
		color: var(--color-white);
		border: 0.056rem solid var(--color-white30);
		white-space: pre-line;
		background-color: inherit;

		p {
			max-width: 14.833rem;
		}

		.title {
			color: var(--color-gray300);
			@include useFont(tsmm);
		}

		&.li-btn {
			height: 6.889rem;
			background-color: var(--color-brand500);
			border-color: var(--color-brand500);

			&:hover {
				background-color: var(--color-brand600);
				border-color: var(--color-brand600);
			}

			.title {
				color: var(--color-white);
			}

			.link {
				width: 100%;
				height: 100%;
				max-width: unset;
				cursor: pointer;
				z-index: var(--z-index);
			}

			.image {
				position: absolute;
				width: 6.889rem;
				height: 6.889rem;
				right: 0;
				bottom: 0;
			}
		}
	}
}

.info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: var(--color-gray300);
	@include useFont(txsm);
	margin-top: 1.333rem;
	padding-bottom: 1.333rem;

	gap: 0.667rem;

	.values {
		display: flex;
		flex-wrap: nowrap;
		gap: 8px;
	}
}

@include screen1920 {
	footer {
		margin-top: 7.778rem;
		padding-inline: var(--layout-pad-x);
		padding-bottom: var(--layout-pad-y);

		section {
			padding: 2.667rem;
			border-radius: 1.333rem;

			.box-image {
				width: 32.222rem;
				height: 24.444rem;
				left: auto;
				top: -1.778rem;
				right: 22.444rem;
			}

			.rect {
				div::before {
					content: '';
					left: auto;
					right: 27rem;
					top: -9.722rem;
					width: 28.889rem;
					height: 28.889rem;
					transform: rotate(75deg);
				}
			}
		}
	}

	.h-text {
		max-width: 45.833rem;
		@include useFont(dxlb);
	}

	.description {
		@include useFont(dxsm);
		margin-top: 1.333rem;
		max-width: 25.667rem;
	}

	.call-us {
		margin-top: 0;

		.btn-call {
			width: fit-content;
		}
	}

	.row-btw {
		display: flex;
		flex-wrap: nowrap;
		align-items: flex-start;
		justify-content: space-between;
	}

	.addresses {
		display: grid;
		grid-template-columns: 23.389rem 23.389rem 1fr;
		grid-auto-rows: 11.111rem;
		column-gap: 1.111rem;
		align-items: center;
		margin-top: 7.333rem;
		background-color: inherit;

		li {
			width: 100%;
			height: 100%;
			border-radius: 1.333rem;
			padding: 1.333rem;
			@include useFont(dxss);

			p {
				max-width: 31.667rem;
			}

			.title {
				@include useFont(tmdm);
			}

			&.li-btn {
				height: 100%;

				.image {
					width: 9.333rem;
					height: 9.333rem;
				}
			}
		}
	}

	.info {
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;
		@include useFont(tmdm);
		margin-top: 2.222rem;
		padding-bottom: 0;

		.values {
			gap: 1.111rem;
		}
	}
}
</style>
